import { useTranslate } from "@refinedev/core";
import { HeadCircuitIcon, RobotIcon, TargetIcon } from "@phosphor-icons/react";
import { ProjectActionCard } from "./ProjectActionCard";
import { ProjectSectionCard } from "./ProjectSectionCard";

interface ProjectPowerFeaturesProps {
  projectId: string;
  storyboardId?: string;
  isLive: boolean;
  instanceId?: string;
}

export const ProjectPowerFeatures: React.FC<ProjectPowerFeaturesProps> = ({
  projectId,
  storyboardId,
  isLive,
  instanceId,
}) => {
  const t = useTranslate();

  const powerFeatures = [
    {
      key: "chatbot",
      route: `/media/projects/${projectId}/chat-history`,
      icon: <RobotIcon size="20px" />,
      label: t("media.components.ProjectPowerFeatures.chatbot"),
      disabled: false,
    },
    {
      key: "ctas",
      route: `/media/projects/${projectId}/${storyboardId}/${instanceId}/settings/ctas`,
      icon: <TargetIcon size="20px" />,
      label: t("media.projects.projectMenu.editCtas"),
      disabled: isLive,
    },
    {
      key: "knowledge-base",
      route: `/media/projects/${projectId}/kb`,
      icon: <HeadCircuitIcon size="20px" />,
      label: t("media.projects.projectMenu.editKnowledgeBase"),
      disabled: isLive,
    },
  ];

  return (
    <ProjectSectionCard
      title={t("media.components.ProjectPowerFeatures.powerFeatures")}
    >
      {powerFeatures.map((feature) => (
        <ProjectActionCard
          key={feature.key}
          route={feature.route}
          icon={feature.icon}
          label={feature.label}
          disabled={feature.disabled}
        />
      ))}
    </ProjectSectionCard>
  );
};
